import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppointmentService } from 'src/app/Services/Appointment/appointment.service'

@Component({
  selector: 'app-appointment-search',
  templateUrl: './appointment-search.component.html',
  styleUrls: ['./appointment-search.component.css']
})
export class AppointmentSearchComponent implements OnInit {

  loading=false;
  searchForm:FormGroup;

  error:any = '';
  success = '';
branchs;

  validationMessages = {
    'fullName': {
      'required': 'Full Name is required'
    },
    'phoneNumber': {
      'required': 'Phone Number is required'
    },
    'branch': {
      'required': 'Branch is required'
    },
  
    'email': {
      'required': 'Email is required',
      'pattern' : 'Please enter a valid email'
    },
  
   
  };
  
  
  formErrors = {
    'fullName': '',
    'phoneNumber': '',
    'email': '',
    'branch': '',
   
  }
  
    constructor(private fb: FormBuilder,
      private router: Router,
      private _location: Location,
      private http: HttpClient,
      private actroute: ActivatedRoute,
      private _appointment: AppointmentService,
      private modalService: NgbModal) { }


  ngOnInit(): void {

    this.getAllBranchs();

    this.searchForm = this.fb.group({
      pid: new FormControl(''),
       fullName: new FormControl('', [Validators.required]),
       phoneNumber: new FormControl('',[Validators.required]),
       email: new FormControl(''),
       branch: new FormControl('',[Validators.required]),
       covid: new FormControl('')
       
     });


 
     //error handling
     this.searchForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.searchForm);
    })
    }


  

    onSubmit(covid){
     
      this.logValidationErrors(this.searchForm );
     // document.getElementById("openWaitModalButton").click();
  
      this.searchForm.patchValue({
        covid: covid,
      email:""});
  
  
     console.log(this.searchForm.value);
           this._appointment.searchAppointment(this.searchForm.get('fullName').value,this.searchForm.get('email').value,this.searchForm.get('phoneNumber').value,this.searchForm.get('branch').value,covid)
        .subscribe(//subscribe to Observable
          response => {console.log(response);
     //     console.log(response[0]);
         // document.getElementById("openNoAppointmentModalButton").remove;
         if(response[0]=="no appointment"){
           
            this.searchForm.reset;  
       //  console.log(response[0]);      
            document.getElementById("openNoAppointmentModalButton").click();
          }else{

          this.success=response['SUCCESS'];
          this.searchForm.reset;        
          document.getElementById("openSuccessFoundAppointmentModalButton").click();}
        },

          error => {console.error('Error!', error);
          this.error=error.error.text ;
          //this.error=error;
        }       
        );
    
            }


proceedtoquestionaire(){
  this.modalService.dismissAll();
  this.router.navigate(['../appointment-questionaire'],{relativeTo:this.actroute});
}

getAllBranchs(){
  this._appointment.getAllBranchs().subscribe(
    (res) => {

      this.branchs = res;
    },
    (err) => {
      this.error = err;
    }
  );
}

  backClicked() {
    this._location.back();
  }



  logValidationErrors(group: FormGroup ): void {
    //get the keys from FormGroup object and checks all the keys
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      //if the key is part of nested FormGroup or any FormGroup then rerun it through the method again to extract formControl
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        //clear any previous error
        this.formErrors[key] = '';
        //check Validation of the formControl
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          //if not valid then get the error message of whatever the validation error is from the validationMessage method
          const messages = this.validationMessages[key];
          //for every error in validation get the error key and assign it to the formControl name is formError method
          for (const errorkey in abstractControl.errors) {
            if (errorkey) {
        //      console.log(key);

              this.formErrors[key] += messages[errorkey] + ''
            }
          }
        }
      }

    });
  }
}
